import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import { EncomendaDto, ListarEncomendaQuery } from "../typings";
import http from "infra/http";

export function useListarEncomenda(query: ListarEncomendaQuery) {
  return useQuery<PaginateResult<EncomendaDto>, AxiosError>(
    [`/v1/encomenda`, query],
    async () => {
      const { data } = await http.get<PaginateResult<EncomendaDto>>(
        "/v1/encomenda",
        { params: query }
      );

      return data;
    }
  );
}
